import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { BallotService } from "../ballot/ballot.service"
import { environment } from "src/environments/environment";
import { ApiAboutService } from "../Services/api-about.service";
import { Ballot } from "../ballot/backend-types";

@Injectable()
export class CanActivateBallot  {
    constructor(
        private router: Router,
        private ballotService: BallotService,
        private about: ApiAboutService
        ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        let ballot: Ballot | undefined = this.ballotService.getBallot();
        let now: number = Date.now();
        let eventOpen: number = new Date(ballot?.eventActivation ?? "0").getTime();
        let eventClosed: number = new Date(ballot?.eventExpiration ?? "8000-01-01").getTime();
        if(this.about.idUploadFlow) {
            return true;
        } else if (ballot === undefined) {
            return this.router.createUrlTree(environment.startRoute)
        } else if((now < eventOpen) || (now > eventClosed)) {
            return false;
        } else {
            return true
        }
    }
}